import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';

export const FieldDescription = ({ className, ...props }: ComponentProps<'p'>) => {
  return <p className={cn('text-muted-foreground text-xs', className)} {...props} />;
};
